module.exports = __webpack_public_path__ + "img/晋国.760558b9.png";